<template>
  <div>
    <!--微信报警-->
    <el-dialog :visible.sync="squadronAlarm.isVisible"
               custom-class="squadron-alarm">
      <div class="alarm-title">
        <span>{{ squadronAlarm.title }}</span>
      </div>
      <div class="alarm-content">
        <p>地址：{{ squadronAlarm.address }}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <img src="~@/assets/img/squadronAlarm-accept.png" @click="wechatSendp()" alt="">
      </div>
    </el-dialog>

    <el-dialog :visible.sync="squadronWechatDispatch.isVisible"
               custom-class="squadron-wechat">
      <div class="wechat-title">
        <span>{{ squadronWechatDispatch.title }}</span>
      </div>
      <div class="wechat-content">
        <el-form label-width="150px">
          <el-form-item label="报警人姓名">
            <span>{{ wecharDao.wechatCluesDO.policeName }}</span>
          </el-form-item>
          <el-form-item label="报警人手机号">
            <span>{{ wecharDao.wechatCluesDO.policePhone }}</span>
          </el-form-item>
          <el-form-item label="火灾定位">
            <span>{{ wecharDao.wechatCluesDO.fireLocation }}</span>
          </el-form-item>
          <el-form-item label="详细地址">
            <span>{{ wecharDao.wechatCluesDO.detailAddress }}</span>
          </el-form-item>
          <el-form-item label="描述">
            <span>{{ wecharDao.wechatCluesDO.describe }}</span>
          </el-form-item>
          <el-form-item label="图片">
            <div class="wechat-img">
              <img src="">
              <img src="">
            </div>
          </el-form-item>
          <el-form-item label="视频">
            <div class="wechat-video">
              <video></video>
            </div>
          </el-form-item>
          <el-form-item label="微型站">
            <el-input @focus="selectStation" v-model="tinySite.names"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <img src="~@/assets/img/squadronAlarm-dispatch.png" @click="faction()" alt="">
      </div>
    </el-dialog>

    <el-dialog :visible.sync="fireAlarm.isVisible"
               custom-class="fire-alarm">
      <div class="alarm-title">
        <span>{{ fireAlarm.title }}</span>
      </div>
      <div class="alarm-content">
        <p>{{ fireAlarm.location }}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <img src="~@/assets/img/squadronAlarm-accept.png" @click="microStand()" alt="">
      </div>
    </el-dialog>

    <el-dialog :visible.sync="fireAlarmDispatch.isVisible"
               custom-class="squadron-wechat alarm-dispatch">
      <div class="wechat-title">
        <span>{{ fireAlarmDispatch.title }}</span>
      </div>
      <div class="wechat-content">
        <el-form label-width="150px">
          <el-form-item label="灾害地址">
            <span>{{ fireAlarmDispatch.alarmsingDo.disasterAddress }}</span>
          </el-form-item>
          <el-form-item label="燃烧物">
            <span>{{ fireAlarmDispatch.alarmsingDo.combustion }}</span>
          </el-form-item>
          <el-form-item label="报警人">
            <span>{{ fireAlarmDispatch.alarmsingDo.masterName }}</span>
          </el-form-item>
          <el-form-item label="报警人电话">
            <span>{{ fireAlarmDispatch.alarmsingDo.contactTelephone }}</span>
          </el-form-item>
          <el-form-item label="报警时间">
            <span>{{ fireAlarmDispatch.alarmsingDo.reportTime }}</span>
          </el-form-item>
          <el-form-item label="微型站">
            <el-input @focus="selectStation" v-model="tinySite.names"></el-input>
          </el-form-item>
          <el-form-item label="出车通讯员" style="margin: 20px 0px">
            <div class="cardTitle">
              <el-checkbox-group v-model="selectCjPersons">
                <el-row :gutter="32">
                  <el-col :span="4" v-for="(item,index) in cjPersons" :key="index">
                    <el-checkbox :label="item" :key="item.id">{{ item.name }}</el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </div>

          </el-form-item>
          <el-form-item label="注意事项" class="dispatch-text">
            <el-input type="textarea" v-model="attention"></el-input>
          </el-form-item>
          <el-form-item label="备注" class="dispatch-text">
            <el-input type="textarea" v-model="remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <img src="~@/assets/img/squadronAlarm-determine-dispatch.png" @click="faction()" alt="">
      </div>
    </el-dialog>
    <el-dialog :visible.sync="tinySite.isVisible"
               custom-class="tiny-site">
      <div class="site-title">
        <span>{{ tinySite.title }}</span>
      </div>
      <div>
        <el-form ref="form" :model="tinySite.form" label-width="0px">
          <el-form-item class="site-search">
            <el-input v-model="tinySite.form.name" placeholder="请输入街道名称" style="width: 350px;"></el-input>
            <img src="~@/assets/img/tinysite-search.png" alt="" class="site-search-img" @click="selectStation()">
          </el-form-item>
        </el-form>
        <el-table
          @selection-change="handleSelectionChange"
          :data="tinySite.tableData"
          border
          height="430px"
          style="width: 100%">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="name"
            label="微站名称"
            width="180">
          </el-table-column>
          <el-table-column
            prop="streetId"
            label="街乡">
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <img src="~@/assets/img/tinysite-determine.png" @click="tinySite.isVisible = false" alt="">
      </div>
    </el-dialog>
    <!-- 火场文书详情 -->
    <el-dialog
      :visible.sync="fireDocuDialog"
       width="80%"
      :class="{'channel-style fireDoc': isRedStyleTp, 'fireDoc':!isRedStyleTp}"
      append-to-body>
      <firePinkAlarm
        ref="firePinkAlarm"
        :alarmId="alarmId"
      ></firePinkAlarm>
    </el-dialog>
    <!-- 微站指派人员  -->
    <el-dialog
      :visible.sync="pinkAlarmDialog"
      style="margin-top:-8vh;"
      width="939px"
      class="endNoticeDialog">
      <firePink :alarmId="alarmId" :q="q" ref="firePink"></firePink>
    </el-dialog>
    <!--火眼报警-->
    <el-dialog :visible.sync="fireEyeAlarm.isVisible"
               :top="fireEyeAlarm.top"
               :append-to-body="true"
               :modal-append-to-body="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               custom-class="fireeye-wrapper">
      <div slot="title" class="fireeye-title">
        <span>{{ fireEyeAlarm.title }}</span>
      </div>
      <div class="fireeye-body">
        <el-form label-width="100px">
          <h1 class="fireeye-h1">报警信息</h1>
          <div class="fireeye-bg fireeye-info">
            <i class="el-icon-time"></i>
            <span>2020-06-08 14:32:24</span>
            <i class="el-icon-location-outline"></i>
            <span>北京市西城区建国大街219号院3号楼5单元三楼</span>
          </div>
          <h1 class="fireeye-h1">选择出警人员</h1>
          <div class="fireeye-bg fireeye-personnel">
            <el-checkbox-group v-model="fireEyeAlarm.personnel">
              <el-checkbox label="1">孙建国</el-checkbox>
              <el-checkbox label="11">孙建国</el-checkbox>
              <el-checkbox label="12">孙建国</el-checkbox>
              <el-checkbox label="13">孙建国</el-checkbox>
              <el-checkbox label="14">孙建国</el-checkbox>
              <el-checkbox label="15">孙建国</el-checkbox>
              <el-checkbox label="16">孙建国</el-checkbox>
              <el-checkbox label="17">孙建国</el-checkbox>
              <el-checkbox label="18">孙建国</el-checkbox>
              <el-checkbox label="19">孙建国</el-checkbox>
              <el-checkbox label="119">孙建国</el-checkbox>
              <el-checkbox label="129">孙建国</el-checkbox>
              <el-checkbox label="139">孙建国</el-checkbox>
              <el-checkbox label="149">孙建国</el-checkbox>
              <el-checkbox label="159">孙建国</el-checkbox>
            </el-checkbox-group>
          </div>
          <h1 class="fireeye-h1">请选择出警装备即数量</h1>
          <div class="fireeye-bg fireeye-num">
            <el-form-item label="手机">
              <el-input-number size="mini" v-model="fireEyeAlarm.form.num" :min="1" :max="10"></el-input-number>
            </el-form-item>
            <el-form-item label="手机">
              <el-input-number size="mini" v-model="fireEyeAlarm.form.num1" :min="1" :max="10"></el-input-number>
            </el-form-item>
            <el-form-item label="防毒面具">
              <el-input-number size="mini" v-model="fireEyeAlarm.form.num2" :min="1" :max="10"></el-input-number>
            </el-form-item>
            <el-form-item label="防护服">
              <el-input-number size="mini" v-model="fireEyeAlarm.form.num3" :min="1" :max="10"></el-input-number>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="fireeye-footer">
        <el-button>出 警</el-button>
      </div>
    </el-dialog>
    <!--烟感报警调度派单-->
    <el-dialog :visible.sync="smokeAlarm.isVisible"
               :top="smokeAlarm.top"
               :append-to-body="true"
               :modal-append-to-body="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               custom-class="smoke-wrapper">
      <div slot="title" class="smoke-title">
        <span>{{ smokeAlarm.title }}</span>
      </div>
      <div class="smoke-content">
        <el-row>
          <el-col :span="5">
            <h1 class="smoke-h1">任务详情</h1>
            <div class="smoke-item smoke-task">
              <el-form label-width="150px">
                <el-form-item label="警情编码："><span>fsfafafaff</span></el-form-item>
                <el-form-item label="持续时间："><span>10分钟</span></el-form-item>
                <el-form-item label="出动单位："><span>年轮骨科医院</span></el-form-item>
                <el-form-item label="报警时间："><span>2020-8-28 18:21:12</span></el-form-item>
                <el-form-item label="灾情地址："><span>灾情地址</span></el-form-item>
                <el-form-item label="接警时间："><span>2020-8-28 18:21:12</span></el-form-item>
                <el-form-item label="是否电话处置："><span>是</span></el-form-item>
                <el-form-item label="到达现场时间："><span>2020-8-28 18:21:12</span></el-form-item>
              </el-form>
            </div>
          </el-col>
          <el-col :span="14">
            <h1 class="smoke-h1">火场文书</h1>
            <div class="smoke-item smoke-fire">
              <el-steps direction="vertical" :active="4">
                <el-step>
                  <div slot="description">
                    <div class="fire-time">
                      <span>2020-06-08 14:32:24</span>
                      <span>红庙消防站</span>
                    </div>
                    <div class="fire-title">119派警</div>
                  </div>
                </el-step>
                <el-step>
                  <div slot="description">
                    <div class="fire-time">
                      <span>2020-06-08 14:32:24</span>
                      <span>年轮微型站</span>
                    </div>
                    <div class="fire-title">微型消防站接警</div>
                  </div>
                </el-step>
                <el-step>
                  <div slot="description">
                    <div class="fire-time">
                      <span>2020-06-08 14:32:24</span>
                      <span>年轮微型站</span>
                    </div>
                    <div class="fire-title">微型消防站派警【李云龙】</div>
                  </div>
                </el-step>
                <el-step>
                  <div slot="description">
                    <div class="fire-time">
                      <span>2020-06-08 14:32:24</span>
                      <span>年轮微型站</span>
                    </div>
                    <div class="fire-title">【李云龙】到达</div>
                  </div>
                </el-step>
                <el-step>
                  <div slot="description">
                    <div class="fire-time">
                      <span>2020-06-08 14:32:24</span>
                      <span>年轮微型站</span>
                    </div>
                    <div class="fire-title">【李云龙】到达</div>
                  </div>
                </el-step>
                <el-step>
                  <div slot="description">
                    <div class="fire-time">
                      <span>2020-06-08 14:32:24</span>
                      <span>年轮微型站</span>
                    </div>
                    <div class="fire-title">【李云龙】到达</div>
                  </div>
                </el-step>
              </el-steps>
              <div class="fire-form">
                <el-form label-width="100px">
                  <el-form-item label="指挥调度">
                    <el-input type="textarea" :rows="5" v-model="smokeAlarm.form.desc" resize="none"></el-input>
                  </el-form-item>
                  <div class="fire-form-btn">
                    <a href="">
                      图片/视频
                    </a>
                  </div>
                </el-form>
              </div>
            </div>
          </el-col>
          <el-col :span="5">
            <h1 class="smoke-h1">战斗组成员</h1>
            <div class="smoke-item smoke-combat">
              <table border="0">
                <tr>
                  <td><span>杨过里</span></td>
                  <td><span>红庙消防站</span></td>
                  <td><span>18032563256</span></td>
                </tr>
                <tr>
                  <td><span>杨国荣</span></td>
                  <td><span>红庙消防站</span></td>
                  <td><span>18032563256</span></td>
                </tr>
                <tr>
                  <td><span>张莉莎</span></td>
                  <td><span>红庙消防站</span></td>
                  <td><span>18032563256</span></td>
                </tr>
                <tr>
                  <td><span>李晓</span></td>
                  <td><span>红庙消防站</span></td>
                  <td><span>18032563256</span></td>
                </tr>
              </table>
              <div class="smoke-map">
                <img src="/">
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firePinkAlarm from "@/pages/fireBook/firePinkAlarm";
import firePink from '@/pages/fireBook/firePink'
import {channelStyleTp, redStyleTp} from "@/js/constants";

export default {
  name: 'dialogBox',
  data() {
    return {
      alarmId:'',
      selectCjPersons: [],
      fireDocuDialog: false,
      pinkAlarmDialog: false,
      q: {
        id: '',
        msgDetail: '',
        smokeName: '烟感报警',
        pinkName: '火眼报警'
      },
      squadronAlarm: {
        title: '微信派警',
        isVisible: false,
        address: ''
      },
      squadronWechatDispatch: {
        title: '微信调度派单',
        isVisible: false
      },
      fireAlarm: {
        title: '119火警派单',
        location: '',
        isVisible: false
      },
      fireAlarmDispatch: {
        title: '119调度派单',
        isVisible: false,
        alarmsingDo: '',
        form: {
          checkList: ''
        }
      },
      attention: '',
      remark: '',
      cjPersons: '',
      tinySite: {
        ids: '',
        names: '',
        title: '选择微站',
        isVisible: false,
        form: {
          name: ''
        },
        tableData: []
      },
      wecharDao: {
        wechatCluesDO: {}
      },
      fireEyeAlarm: {
        top: '12vh',
        title: '火眼报警',
        isVisible: false,
        personnel: [],
        form: {
          num: '',
          num1: '',
          num2: '',
          num3: '',
        }
      },
      smokeAlarm: {
        top: '12vh',
        title: '烟感报警调度派单',
        isVisible: false,
        form: {
          desc: ''
        }
      }
    }
  },
  components: {
    firePinkAlarm,
    firePink
  },
  computed: {
    isRedStyleTp () {
      return this.$store.state.styleTp === redStyleTp
    }
  },
  methods: {
    wechatSendp() {
      let _this = this;
      let deptStatus = _this.$store.state.deptStatus;
      _this.$emit("stopBellRing");
      if (deptStatus === '0') {
        _this.squadronAlarm.isVisible = false
        _this.$router.push("/weCharFire")
      } else if (deptStatus === '2') {//微站
        _this.$emit("stopBellRing");
        _this.pinkAlarmDialog = true;
      } else if (deptStatus === '3') {

      }
// else if (deptStatus === '1') {//中队
//         _this.squadronAlarm.isVisible = false
//         _this.squadronWechatDispatch.isVisible = true
//         _this.firebook();
//       }
    },
    firebook() {
      let _this = this;
      let success = function (resp) {
        _this.wecharDao = resp
      }
      _this.http.get('/webapi/alarmWechat/' + _this.alarmId, null, success);
    },
    wechatFire(data) {
      let _this = this;
      _this.squadronAlarm.address = data.msgDetail;
      _this.squadronAlarm.isVisible = true;
    },
    alarm119(id) {  //中队弹屏
      let _this = this;
      _this.alarmId = id;
      let success = function (resp) {
        if (resp.alarmSingle.singleState == '0') {
          _this.fireAlarm.location = resp.alarmSingle.disasterAddress;
          _this.fireAlarm.isVisible = true;
        } else {
          _this.squadronAlarm.address = resp.alarmSingle.disasterAddress;
          _this.squadronAlarm.isVisible = true;
        }
      }
      _this.http.get('/webapi/alarm119/' + _this.alarmId, {}, success);
    },
    microStand() {
      let _this = this;
      this.$emit("stopBellRing");
      var success = function (resp) {
        if (_this.$store.state.deptStatus == '1') {
          _this.fireAlarm.isVisible = false;
          _this.fireAlarmDispatch.isVisible = true;
          _this.cjPersons = resp.user;
          _this.fireAlarmDispatch.alarmsingDo = resp.alarmSingleDO;
        } else {
          _this.pinkAlarmDialog = true;
        }
      }
      _this.http.get('/webapi/writ/alarmisng/' + _this.alarmId, {}, success);
    },
    selectStation() {
      let _this = this;
      _this.tinySite.isVisible = true;
      let data = {
        streetId: _this.tinySite.form.name
      }
      let success = function (resp) {
        _this.tinySite.tableData = resp.data.records;
      }
      _this.http.get('/wxf/alarmSingle/chooseDeptList', data, success);
    },
    handleSelectionChange(val) {
      let ids = '';
      let names = '';
      for (const object of val) {
        ids += object.id + ","
        names += object.name + "   "
      }
      this.tinySite.ids = ids
      this.tinySite.names = names
    },
    faction() {
      let _this = this;
      let ids = ''
      _this.selectCjPersons.map(item => {
        ids += item.id + ",";
      });
      let data = {
        alarmCommanderIds: ids,//通讯员人员id集合
        alarmDeptIds: this.tinySite.ids,   //部门id集合
        wzList: this.tinySite.names,   //部门名称
        matters: this.attention,  //注意事项
        id: this.alarmId,  //任务id
        remarks: this.remark  //备注
      };
      let success = function (resp) {
        if (resp.code === "0") {
          _this.$message.success("指派微站成功");
          _this.fireAlarmDispatch.isVisible = false
          _this.fireDocuDialog = true
        } else {
          _this.$message.success("指派微站失败");
        }
      }
      this.http.post('/webapi/writ/save', data, success);
    },
  },
}
</script>

<style lang="less">
.dialog-footer {
  text-align: center;

  img {
    cursor: pointer;
  }
}

.squadron-alarm, .fire-alarm {
  .el-dialog__body {
    padding: 10px 20px;
  }
}

.squadron-alarm, .fire-alarm, .squadron-wechat, .tiny-site {
  .el-dialog__header {
    .el-dialog__title, .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }
  }

  background-image: repeating-linear-gradient(#747474 0%, #3b3b3b 3%, #3b3b3b 97%, #2b2a2a 100%);
  background-color: #3B3B3B !important;
  border-radius: 18px;
  text-shadow: none;
  width: 586px;
  height: 388px;

  .alarm-title {
    padding-top: 44px;
    text-align: center;

    span {
      font-size: 30px;
      font-weight: bold;
      letter-spacing: 2px;
      color: #fff;
      text-shadow: 0 -3px 3px rgba(0, 0, 0, 0.9);
    }
  }

  .alarm-content {
    padding: 40px 0;
    text-align: center;

    p {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 30px;

    }
  }
}

.squadron-wechat {
  width: 939px;
  height: 938px;

  .el-dialog__body {
    padding: 0px 20px;
  }

  .wechat-title {
    padding-top: 14px;
    padding-bottom: 20px;
    text-align: center;

    span {
      font-size: 30px;
      font-weight: bold;
      letter-spacing: 2px;
      color: #fff;
      text-shadow: 0 -3px 3px rgba(0, 0, 0, 0.9);
    }
  }

  .wechat-content {
    width: 770px;
    height: 660px;
    overflow-y: auto;
    margin: 0px auto;
    border: 1px solid #FFFFFF;
    border-radius: 10px;
    padding: 30px 36px;

    .el-form {
      .el-form-item {
        margin-bottom: 5px;

        .el-form-item__label {
          padding-right: 30px;
        }

        .el-form-item__label, .el-form-item__content {
          font-size: 18px;
          font-family: Source Han Sans CN;
          color: #FFFFFF;
          line-height: 40px;
        }
      }
    }

    .wechat-img {
      img {
        width: 198px;
        height: 122px;
        margin-right: 20px;
        background: #000000;
        border-radius: 10px;
      }

      img:last-child {
        margin-right: 0px;
      }
    }

    .wechat-video {
      video {
        width: 244px;
        height: 150px;
        margin-right: 20px;
        background: #000000;
        border-radius: 10px;
      }

      video:last-child {
        margin-right: 0px;
      }
    }
  }
}

.alarm-dispatch {
  height: auto;

  .wechat-content {
    height: auto;
  }

  .dispatch-checkbox {
    label {
      width: 132px;
      height: 39px;
      display: inline-block;
      text-align: center;
      text-decoration: none;
      margin-right: 20px;
      color: #FFFFFF;
      border: 1px solid #FFFFFF;
      border-radius: 20px;
    }

    label:last-child {
      margin-right: 0px;
    }

    label:hover, label.active {
      background: #EDEB70;
      border: 1px solid #EDEB70;
      color: #3B3B3B;
    }
  }

  .dispatch-text {
    margin-bottom: 20px !important;

    .el-textarea .el-textarea__inner {
      height: 84px;
    }
  }
}

.tiny-site {
  width: 839px;
  height: 781px;

  .el-dialog__body {
    padding: 0px 50px;
  }

  .site-title {
    padding-top: 14px;
    padding-bottom: 20px;
    text-align: center;

    span {
      font-size: 30px;
      font-weight: bold;
      letter-spacing: 2px;
      color: #fff;
      text-shadow: 0 -3px 3px rgba(0, 0, 0, 0.9);
    }
  }

  .site-search {
    position: relative;
    padding: 20px 0px;

    .site-search-img {
      position: absolute;
      left: 300px;
      cursor: pointer;
      top: -12.5px;
    }
  }

  .el-table {
    background: transparent;
  }

  .el-table thead th, .el-table thead tr {
    background: #3B3B3B !important;

    .cell {
      font-size: 18px;
      color: #fff;
    }
  }

  .el-table th, .el-table tr, .el-table th:hover, .el-table tr:hover {
    background: #3B3B3B !important;
    color: #fff;
  }

  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background: #3B3B3B !important;
  }

  .el-table tr td .cell {
    text-align: left;
  }

  .el-dialog__footer {
    padding-top: 30px;
  }
}

.fireDoc {
  .el-dialog__header {
    background-color: #0080DB;
    .el-dialog__headerbtn{
      .el-icon-close{
        color:#fff
      }
    }

    .el-dialog__title {
      color: rgb(247, 247, 247);
    }
  }
}
// 渠道样式
.red-theme-dialog {
  .el-dialog__header {
    background-color: #f3787d !important;
    .el-dialog__title{
      color: #fff;
      font-weight: bold;
    }
  }
  .dialog-title {
    &::before {
      background-color: #f3787d !important;
    }
  }

  .bfyr-tel {
    a {
      background: #f3787d !important;
      color: #fff !important;
    }
  }
}
.electric-wrapper{
  .el-dialog__header{
    text-align: center;
    font-size: 24px;
  }
}
.endNoticeDialog {
  .el-dialog {
    background: #ffffff !important;
    border-radius: 18px;

    // .el-dialog__header {
    //   display: none;
    // }
  }
}

.fireeye-wrapper {
  width: 855px;
  border-radius: 21px;

  .el-dialog__header {
    padding: 0;

    .fireeye-title {
      height: 57px;
      background: #0080DB;
      border-radius: 21px 21px 0px 0px;
      text-align: center;
      line-height: 57px;

      span {
        font-size: 24px;
        font-family: Source Han Sans CN;
        color: #FFFFFF;
      }
    }
  }

  .el-dialog__body {
    padding: 0px 20px;

    .fireeye-body {
      h1.fireeye-h1 {
        height: 18px;
        line-height: 18px;
        font-weight: normal;
        font-size: 18px;
        color: #333333;
        margin: 22px 0;
        text-align: center;
      }

      .fireeye-bg {
        width: 720px;
        background: rgba(200, 232, 255, 0.3);
        margin: 0px auto;
        padding: 10px 0px;
        border-radius: 8px;
        overflow: hidden;
      }

      .fireeye-info {
        padding: 30px 0px;
        text-align: center;

        i {
          color: #0080DB;
          font-size: 18px;
          margin: 0px 10px;
        }

        span {
          font-size: 16px;
          font-family: Source Han Sans CN;
          color: #333333;
        }
      }

      .fireeye-personnel {
        .el-checkbox {
          margin: 10px 39px;
        }
      }

      .fireeye-num {
        .el-form-item {
          width: 50%;
          height: 40px;
          float: left;
        }
      }
    }
  }

  .el-dialog__footer {
    .fireeye-footer {
      text-align: center;
      padding-top: 20px;
      padding-bottom: 10px;

      button.el-button {
        width: 206px;
        height: 43px;
        background: #0080DB;
        border-radius: 22px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        color: #FFFFFF;
      }
    }
  }
}

.smoke-wrapper {
  width: 1640px;
  border-radius: 21px;

  .el-dialog__header {
    padding: 0;

    .smoke-title {
      height: 57px;
      background: #0080DB;
      border-radius: 21px 21px 0px 0px;
      text-align: center;
      line-height: 57px;

      span {
        font-size: 24px;
        font-family: Source Han Sans CN;
        color: #FFFFFF;
      }
    }
  }

  .smoke-content {
    padding: 0;

    h1.smoke-h1 {
      font-size: 16px;
      padding: 10px 0;
      font-family: Source Han Sans CN;
      color: #333333;
      line-height: 25px;
      font-weight: normal;
      text-align: center;

    }

    .smoke-item {
      height: 540px;
      padding: 20px 0;
      background: rgba(200, 232, 255, 0.3);
      border-radius: 8px;

    }

    .smoke-task {
      padding: 20px;

      .el-form-item {
        margin-bottom: 0px;
        border-bottom: 1px dashed #eaeaea;
      }
    }

    .smoke-fire {
      margin: 0 16px;

      .el-steps {
        height: 348px;
        padding: 0px 20px 40px;
        overflow-y: auto;
      }

      .fire-time {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #9C9C9C;

        span {
          padding: 0px 10px;
        }
      }

      .fire-title {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        padding: 20px 10px 10px;

      }

      .fire-form {
        box-shadow: 0px -5px 5px #eaeaea;
        padding: 20px 20px;
        height: 110px;

        .el-form-item {
          margin-bottom: 0px;
        }

        div.fire-form-btn {
          padding: 10px 0px 5px 100px;

          a {
            font-size: 12px;
            color: #A0A0A0;
            text-decoration: none;
          }
        }
      }
    }

    .smoke-combat {
      .smoke-con {
        padding-left: 20px;
      }

      table {
        width: 100%;

        td {
          text-align: center;
          padding: 17px 0;

          span {
            font-size: 14px;
            font-family: Source Han Sans CN;
            color: #333333;
          }
        }
      }

      .smoke-map {
        padding: 10px;

        img {
          display: block;
          width: 100%;
          height: 150px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialogBox.vue